(function() {
    'use strict';

    angular.module('machine')
        .controller('MachineActionUpdateController', MachineActionUpdateController);

    MachineActionUpdateController.$inject = ['$uibModalInstance', 'row'];

    function MachineActionUpdateController($uibModalInstance, row) {
        var self = this;

        self.actionData = row;
        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close(self.actionData);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
